import loadable from "@loadable/component";
import Preloader from "./preloader.js";

export const Home = loadable(() => import("pages/home/home"), {
  LoadingComponent: Preloader,
});
